export default __webpack_public_path__ + "static/media/block2.30489522.webp";